// extracted by mini-css-extract-plugin
module.exports = {"iframeWrap":"_35XkXsxS1RVUZtbDnNILnu"};